import * as types from './mutation-types';

const mutations = {
  [types.SHIELDS_BY_DEVICE_ID](state, { deviceId, shields }) {
    state.shieldsByDeviceId = {
      ...state.shieldsByDeviceId,
      [deviceId]: shields,
    };
  },
  [types.DEVICES_BY_SHIELD_ID](state, { shieldId, devices }) {
    state.devicesByShieldId = {
      ...state.devicesByShieldId,
      [shieldId]: devices,
    };
  },
  [types.DEVICES_BY_USER_ID](state, devices) {
    state.devicesByUserId = devices;
  },
  [types.SHIELDS_BY_USER_ID](state, shields) {
    state.shieldsByUserId = shields;
  },
};

export default mutations;
